import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';

const CancellationsUIContext = createContext();
const { initialFilter } = UIHelpers();

export function useCancellationsUIContext () {
    return useContext(CancellationsUIContext);
}

export const CancellationsUIConsumer = CancellationsUIContext.Cancellation;

export function CancellationsUIProvider ({ cancellationsUIEvents, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const cancellation = {};

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        cancellation
    };

    return <CancellationsUIContext.Provider value={value}>{children}</CancellationsUIContext.Provider>;
}
